<template>
  <div>
    <b-row class="">
      <b-col cols="12">
        <b-card>
          <div slot="header">
            ایجاد
            <strong>{{$lang.article}} </strong>
          </div>
          <div class="text-center" v-show="isLoading">
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
          </div>
          <articlesForm
            v-show="!isLoading"
            ref="familyRelationForm"
            :item="item"
            @cancel="close"
            @submit="save"
          />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import articlesForm from "./../forms/articlesForm";
export default {
  components: {
    articlesForm,
  },
  inject: ["personArticleRepository"],
  props: {
    itemId: {
      type: [String, Number],
    },
    relation_type_id: {
      type: [String, Number],
    },
    code: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isLoading: false,
      item: {},
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    async save(payload) {
      try {
        this.isLoading = true;
        const response = await this.personArticleRepository.create(
          payload,
          this.code,
          this.itemId
        );
        this.$notify.success(response.data.message);
        this.close();
        this.$emit("getData");
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  async created() {},
};
</script>
